import * as React from 'react'
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation'
import Button from '@mui/material/Button'
import DialogContent from '@mui/material/DialogContent'
import { BootstrapDialog, BootstrapDialogTitle } from 'common/AbstractModal/BootstrapDialog'

import { CancelExternalPlanForm } from './CancelExternalPlanForm'

export interface ChangeCatalogPriceDialogProps {
  orderID: string
  userId: string
}

export default function CancelExternalPlanDialog({
  orderID,
  userId
}: ChangeCatalogPriceDialogProps) {
  const [open, setOpen] = React.useState(false)
  const handleClickOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  //handle form submit api here
  return (
    <div>
      <Button variant='contained' onClick={handleClickOpen}>
        <CancelPresentationIcon />
      </Button>

      <BootstrapDialog
        fullWidth
        maxWidth='lg'
        onClose={handleClose}
        aria-labelledby='customized-dialog-title'
        open={open}
      >
        <BootstrapDialogTitle onClose={handleClose}>
          Cancel Plan
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <CancelExternalPlanForm
            orderID={orderID}
            userId={userId}
            handleClose={handleClose}
          />
        </DialogContent>
      </BootstrapDialog>
    </div>
  )
}
